export default __webpack_public_path__ + "static/media/Polygon.9f9de526.svg";